import { Reducer } from 'redux';
import { TradesActionTypes } from '../actions';
import { initialTradesStoreState, TradesStoreModel } from '../store.model';

export const tradesReducer: Reducer<TradesStoreModel> = (
  state = initialTradesStoreState,
  action
) => {
  switch (action.type) {
    case TradesActionTypes.STORE_ACTIVE_TRADE:
      return { ...state, trade: action.payload };
    case TradesActionTypes.STORE_ACTIVE_POSITION:
      return { ...state, position: action.payload };
    default:
      return state;
  }
};